import { render, staticRenderFns } from "./XhProduct.vue?vue&type=template&id=de43192c&scoped=true"
import script from "./XhProduct.vue?vue&type=script&lang=js"
export * from "./XhProduct.vue?vue&type=script&lang=js"
import style0 from "./XhProduct.vue?vue&type=style&index=0&id=de43192c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de43192c",
  null
  
)

export default component.exports